export default function BrickHeader({ left, right }) {
  return (
    <div className="brick-wall w-full" data-testid="brick-header">
      <div className="max-w-5xl mx-auto px-3 sm:px-6 grid grid-cols-[1fr_auto_1fr] items-center gap-2 py-5 sm:py-6">
        <div className="justify-self-start">{left}</div>
        <div className="justify-self-center">
          <a href="/" data-testid="header-home-link"
            className="title-box inline-block px-4 py-2 sm:px-7 sm:py-3 text-sm sm:text-xl cursor-pointer transition-colors hover:bg-[#1a1a1a]">
            Bautagebuch
          </a>
        </div>
        <div className="justify-self-end">{right}</div>
      </div>
    </div>
  );
}
